<template>
  <div class="fund-history-wrap">
    <div class="fund-history-legend">
      <span class="history-legend-item1" v-if="lrActive === 0">
        <span class="legend-icon1 legend-icon"></span><span class="legend-icon2 legend-icon"></span>
        {{ legend1 }}
      </span>
      <span class="history-legend-item1" v-if="lrActive === 1">
        <span class="legend-icon"></span>
        {{ legend1 }}
      </span>
      <span class="history-legend-item2" v-if="legend2">
        <span class="legend-icon"></span>{{ legend2 }}
      </span>
    </div>
    <div class="fund-history-chart" ref="history"></div>
    <div ref="historymark" @mouseout="resetPoint"></div>
    <a-radio-group
      class="fund-history-radio"
      :options="options"
      v-model="value"
      @change="onChange"
    />
  </div>
</template>

<script>
import { getHistory, getHistoryIndex } from '../../assets/js/action';
import event from '../event';
import { post } from '../../assets/js/request';
import { url, hsgtNetBuyAndAccumulatedNetBuyParams } from '../../assets/js/config';
import { formateDateByTimestampInSeconds } from '../../common/utils/handleCaptialFlowChartData';

export default {
  props: {
    options: Array,
    lrActive: Number, // 流入 tab 索引
    spaceActive: Number, // 日/周/月 tab 索引
    name: String, // 北向 or 南向
  },
  data() {
    return {
      value: this.options[0],
      historyData: {},
      historyIndexData: {},
      legend1: this.name === 'north' ? '北向资金净买入(人民币)' : '南向资金净买入(港币)',
      legend1Flag: '净流入',
      legend2: '' /* this.name === 'north' ? '上证指数走势' : '恒生指数走势' */,
      hisName: '',
      indexStat: '',
      colorConfig: '#19191b',
      fileColorConfig: '#1d2124',
      borderColoronfig: '#2d2f34',
      bcColor: 'none',
    };
  },
  created() {
    // var url = window.location.href;
    var url = document.referrer;
    var a = url.split('?');
    var b = a[1].split('&');
    var theme = null;
    for (let i = 0; i < b.length; i++) {
      let arr = b[i].split('=');
      if (arr[0].replace(/(^\s*)|(\s*$)/g, '') == 'theme') {
        theme = arr[1];
      }
    }
    if (theme == 'newblack') {
      this.colorConfig = '#fff';
      this.fileColorConfig = 'rgba(94,146,228,0.2)';
      this.borderColoronfig = '#ececf7';
      this.bcColor = '#aaa';
    } else if (theme == 'newgrey') {
      this.colorConfig = '#181c21';
      this.fileColorConfig = '#1d2124';
      this.borderColoronfig = '#2d2f34';
    } else {
      this.colorConfig = '#19191b';
      this.fileColorConfig = '#1d2124';
      this.borderColoronfig = '#2d2f34';
    }
  },
  mounted() {
    if (this.name === 'north') {
      this.handleData();
    }
    this.getSelect(this.name);
    if (this.name === 'north') {
    } else {
      this.getHistoryData(this.name, 'day');
    }
  },
  watch: {
    lrActive(val) {
      // 监听流入tab切换
      this.legend1Flag = val === 0 ? '净买入' : '累计净买入';
      this.legend1 =
        this.value + this.legend1Flag + (this.name === 'north' ? '(人民币)' : '(港币)');
      this.initChart(this.historyData, this.historyIndexData);
      // 切换逐日累计的埋点
      let stat = val === 0 ? 'zrlr' : 'ljlr';
      let nameStat = this.name === 'north' ? 'bxls' : 'nxls';
      window.TA.log({
        id: `webhsgt_${nameStat}_${stat}`,
      });
    },
    spaceActive(val) {
      // 监听日期切换
      let nameStat = this.name === 'north' ? 'bxls' : 'nxls';
      let stat = '';
      if (val === 0) {
        this.getHistoryData(this.name, 'day');
        stat = 'day';
      } else if (val === 1) {
        this.getHistoryData(this.name, 'week');
        stat = 'week';
      } else if (val === 2) {
        this.getHistoryData(this.name, 'month');
        stat = 'month';
      } else if (val === 3) {
        this.getHistoryData(this.name, 'quarter');
        stat = 'season';
      } else if (val === 4) {
        this.getHistoryData(this.name, 'year');
        stat = 'year';
      }
      this.switchIndex(this.hisName);
      window.TA.log({
        id: `webhsgt_${nameStat}_${stat}`,
      });
    },
    historyData(val) {
      this.initChart(val, this.historyIndexData);
    },
  },
  methods: {
    async getHsgtNetBuyAndAccumulatedNetBuyData() {
      const params = hsgtNetBuyAndAccumulatedNetBuyParams;
      const data = await post(url.indexInterval, params);
      return data;
    },

    //北向资金净买入近1500交易日数据
    async handleData() {
      const res = await this.getHsgtNetBuyAndAccumulatedNetBuyData();
      if (res && res.data) {
        const timeRange = res.data.time_range;
        const formateTimeRange = this.handleDate(timeRange);
        const data = res.data.data;
        const indexesData = res.data.indexes;
        const indexes = ['hsgt_net_buy', 'hsgt_accumulated_net_buy'];
        const obj = {};
        const result = {
          zhuri: {},
          leiji: {},
        };
        indexes.forEach(item => {
          obj[item] = {};
          const indexIndex = indexesData.findIndex(val => val.index_id === item);
          if (indexIndex !== -1) {
            data.forEach(value => {
              const values = value.values;
              const res = values.find(content => content.idx === indexIndex);
              if (res) {
                obj[item][value['code']] = res.values;
              }
            });
          }
        });
        result['zhuri']['date'] = formateTimeRange;
        result['zhuri']['total'] = obj['hsgt_net_buy']['48:883957'];
        result['zhuri']['h'] = obj['hsgt_net_buy']['16:1A0001'];
        result['zhuri']['s'] = obj['hsgt_net_buy']['32:399001'];
        result['leiji']['date'] = formateTimeRange;
        result['leiji']['total'] = obj['hsgt_accumulated_net_buy']['48:883957'];
        result['leiji']['h'] = obj['hsgt_accumulated_net_buy']['16:1A0001'];
        result['leiji']['s'] = obj['hsgt_accumulated_net_buy']['32:399001'];
        this.historyData = result;
      }
    },

    //处理日期
    handleDate(val) {
      return val.map(item => {
        return formateDateByTimestampInSeconds(item);
      });
    },

    //处理

    onChange(e) {
      // this.legend1Flag = this.lrActive === 0 ? '净流入' : '累计流入'
      this.legend1Flag = this.lrActive === 0 ? '净买入' : '累计净买入';
      this.legend1 =
        e.target.value + this.legend1Flag + (this.name === 'north' ? '(人民币)' : '(港币)');
      this.initChart(this.historyData, this.historyIndexData);
      // 埋点
      let checkedStat = '';
      let nameStat = this.name === 'north' ? 'bxls' : 'nxls';
      if (e.target.value === '北向资金') {
        checkedStat = 'bxzj';
      } else if (e.target.value === '南向资金') {
        checkedStat = 'nxzj';
      } else if (e.target.value === this.options[1]) {
        checkedStat = 'hgt';
      } else {
        checkedStat = 'sgt';
      }
      window.TA.log({
        id: `webhsgt_${nameStat}_${checkedStat}`,
      });
    },
    getSelect(name) {
      // 监听下拉菜单变化
      event.subscribe('selcted' + name, data => {
        this.hisName = data;
        this.legend2 = data;
        this.switchIndex(data);

        // 埋点
        let nameStat = name === 'north' ? 'bxls' : 'nxls';
        let stat = this.indexStat;
        window.TA.log({
          id: `webhsgt_${nameStat}_djzs_${stat}`,
        });
      });
    },
    getHistoryData: function (type, date) {
      // 获取资金历史走势数据
      getHistory(type, date).then(data => {
        this.historyData = data.data.data;
      });
    },
    getHistoryIndexData: async function (code, period) {
      if (!code) {
        this.historyIndexData = {};
        this.initChart(this.historyData, this.historyIndexData);
      }
      // 获取历史走势指数数据
      this.historyIndexData = await getHistoryIndex(code, period);
      this.initChart(this.historyData, this.historyIndexData);
    },
    switchIndex(name) {
      let period = 0; // 修改为所有指数叠加使用日线数据叠加
      switch (name) {
        case '上证指数':
          this.getHistoryIndexData('16_1A0001', period);
          this.indexStat = 'szzs';
          break;
        case '深证成指':
          this.getHistoryIndexData('32_399001', period);
          this.indexStat = 'szcz';
          break;
        case '创业板指':
          this.getHistoryIndexData('32_399006', period);
          this.indexStat = 'cybz';
          break;
        case '上证50指数':
          this.getHistoryIndexData('16_1B0016', period);
          this.indexStat = 'sz50';
          break;
        case '恒生指数':
          this.getHistoryIndexData('176_HSI', period);
          this.indexStat = 'hszs';
          break;
        case '恒生综合大型指数':
          this.getHistoryIndexData('176_HSLI', period);
          this.indexStat = 'hsdx';
          break;
        case '恒生综合中型指数':
          this.getHistoryIndexData('176_HSMI', period);
          this.indexStat = 'hszx';
          break;
        case '恒生综合小型指数':
          this.getHistoryIndexData('176_HSSI', period);
          this.indexStat = 'hsxx';
          break;
        default:
          this.getHistoryIndexData(null, period);
          this.indexStat = 'djzs';
      }
    },
    resetPoint() {
      this.$refs.historymark.innerHTML = '';
    },
    initChart(data, indexData) {
      this.$refs.historymark.innerHTML = ''; // 初始化重置流入浮窗
      let el = this.$refs.history;
      let chart = window.echarts.init(el);
      let type = this.lrActive === 1 ? 'line' : 'bar';
      // 走势图数据处理
      let chartData = {};
      let y1 = [];
      if (this.lrActive === 0) {
        chartData = data.zhuri;
      } else {
        chartData = data.leiji;
      }
      if (this.value === this.options[0]) {
        y1 = chartData.total;
      } else if (this.value === this.options[1]) {
        y1 = chartData.h;
      } else {
        y1 = chartData.s;
      }
      let markPoint = [];
      if (Array.isArray(chartData.map) && this.value === '北向资金' && this.spaceActive === 0) {
        for (let i = 0; i < chartData.map.length; i++) {
          markPoint.push({
            coord: [chartData.map[i].date, chartData.map[i].value],
            symbolSize: [30, 25],
            label: {
              show: true,
              formatter: () => {
                return chartData.map[i].state === 'in' ? '入' : '出';
              },
            },
            itemStyle: {
              color: this.bcColor,
              borderColor: '#0077d0',
            },
          });
        }
      }
      // 获取K线数据
      let xDataIndex = [];
      let yDataIndex = [];
      let _indexData = [];
      if (indexData.data) {
        indexData.data.split(';').map(d => {
          _indexData.push(d.split(','));
        });
        for (let i = 0; i < _indexData.length; i++) {
          if (
            chartData.date.indexOf(
              _indexData[i][0].replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3')
            ) !== -1
          ) {
            xDataIndex.push(_indexData[i][0].replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3'));
            yDataIndex.push(_indexData[i][4]);
          }
        }
      }
      chart.setOption({
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            let firstData =
              params[0].value !== '--' && !isNaN(params[0].value / 1e8)
                ? (params[0].value / 1e8).toFixed(2) + '亿'
                : '--';
            if (params.length > 1) {
              return `
                                <div style="padding:12px 14px;background:#131315;border:1px solid #484848;border-radius:1px;opacity:0.8;">
                                    <div>${params[0].axisValue}</div>
                                    <div>${params[0].marker} ${this.legend1}:${firstData}</div>
                                    <div>${params[1].marker} ${this.legend2}:${params[1].value}</div>
                                </div>
                            `;
            } else {
              return `
                                <div style="padding:12px 14px;background:#131315;border:1px solid #484848;border-radius:1px;opacity:0.8;">
                                    <div>${params[0].axisValue}</div>
                                    <div>${params[0].marker} ${this.legend1}:${firstData}</div>
                                </div>
                            `;
            }
          },
        },
        grid: {
          left: 28,
          right: 15,
          top: 25,
          bottom: 28,
          containLabel: true,
        },
        animation: false,
        xAxis: {
          type: 'category',
          axisTick: { show: false },
          axisLabel: {
            color: '#5b5b5b',
            fontFamily: 'SimSun',
            align: 'center',
            formatter: function (value, index) {
              return index ? value : '';
            },
          },
          data: chartData.date,
        },
        yAxis: [
          {
            splitLine: { show: false },
            axisLabel: {
              color: '#717171',
              showMinLabel: true,
              showMaxLabel: true,
              formatter: function (value) {
                return (value / 1e8).toFixed(0);
              },
              fontFamily: 'SimSun',
            },
            min: function (value) {
              if (value.min > 0) {
                return value.min / 1.1;
              }
              return value.min * 1.1;
            },
          },
          {
            splitLine: { show: false },
            axisTick: { show: false },
            axisLabel: {
              color: '#717171',
              // inside: true,
              showMinLabel: true,
              showMaxLabel: true,
              formatter: function (value) {
                return value.toFixed(0);
              },
              fontFamily: 'SimSun',
            },
            interval: 10000,
            min: function (value) {
              return value.min;
            },
            max: function (value) {
              return value.max;
            },
          },
        ],
        dataZoom: [
          {
            height: 24,
            bottom: 0,
            start: chartData.date.length > 20 ? 95 : 20,
            end: 100,
            fillerColor: this.fileColorConfig,
            borderColor: this.borderColoronfig,
            realtime: false,
            textStyle: false,
            minValueSpan: 3,
          },
          {
            type: 'inside',
            height: 18,
          },
        ],
        series: [
          {
            type: type,
            data: y1,
            itemStyle: {
              color: function (params) {
                return params.value > 0 ? '#c63031' : '#22ac38';
              },
            },
            lineStyle: {
              color: '#c63031',
              width: 1,
            },
            symbol: 'none',
            markPoint: { data: markPoint },
          },
          {
            type: 'line',
            data: yDataIndex.length ? yDataIndex : [],
            itemStyle: {
              color: '#2e96ff',
            },
            lineStyle: {
              color: '#2e96ff',
              width: 1,
            },
            yAxisIndex: 1,
            symbol: 'none',
          },
        ],
      });
      chart.on('datazoom', () => {
        window.TA.log({
          id: `webhsgt_bxzj_zoom`,
        });
      });
      if (markPoint.length) {
        let _this = this;
        chart.on('mouseover', function (params) {
          if (params.componentType === 'markPoint') {
            let value = params.data.coord[1];
            let left = params.event.offsetX - 57;
            let top = params.event.offsetY;
            let popData = params.data.coord[0];
            _this.$refs.historymark.innerHTML = `
                            <div class="fund-mark-point" popData="${popData}" valData="${value}" style="left:${left}px;top:${top}px">
                                大幅净${value > 0 ? '买入' : '卖出'}${Math.abs(
              (value / 1e8).toFixed(0)
            )}亿
                            </div>
                        `;
            // hover 埋点
            let inStat = value > 0 ? 'flowin' : 'flowout';
            window.TA.log({
              id: `webhsgt_bxls_${inStat}_hover`,
            });
          }
        });
      } else {
        this.$refs.historymark.innerHTML = '';
      }
    },
  },
};
</script>

<style lang="less">
.fund-history-wrap {
  position: relative;
  .fund-history-legend {
    width: 100%;
    height: 26px;
    text-align: center;
    line-height: 26px;
    color: #5b5b5b;
    font-size: 12px;
    .history-legend-item1 {
      padding-right: 12px;
      .legend-icon {
        display: inline-block;
        width: 8px;
        height: 2px;
        margin-bottom: 4px;
        background: #c63031;
        &.legend-icon1 {
          margin-right: 3px;
        }
        &.legend-icon2 {
          background: #22ac38;
          margin-right: 4px;
        }
      }
    }
    .history-legend-item2 {
      padding-left: 12px;
      .legend-icon {
        display: inline-block;
        width: 8px;
        height: 2px;
        background: #2e96ff;
        margin-right: 4px;
        margin-bottom: 4px;
      }
    }
  }
  .fund-history-chart {
    height: 210px;
    > div:last-child {
      background: none !important;
    }
  }
  .fund-mark-point {
    padding: 8px 13px;
    font-size: 12px;
    position: absolute;
    color: #fff;
    z-index: 1;
    background-color: #14293a;
    border: 1px solid #0077d0;
    border-radius: 1px;
    cursor: pointer;
  }
  .fund-history-radio {
    width: 100%;
    height: 26px;
    line-height: 26px;
    text-align: center;
    .ant-radio-wrapper {
      .ant-radio-inner {
        width: 13px;
        height: 13px;
        background: #393939;
        border: 1px solid #484848;
        &::after {
          width: 7px;
          height: 7px;
          background-color: #bdbdbd;
          left: 2px;
          top: 2px;
        }
      }
      span {
        font-size: 12px;
        color: #858585;
      }
    }
  }
}
.newblack {
  .fund-history-wrap {
    .fund-history-legend {
      color: #272841;
    }
    .fund-history-radio {
      .ant-radio-wrapper {
        .ant-radio-inner {
          background: #fff;
          border: 1px solid #272841;
        }
        .ant-radio-inner:after {
          background-color: #272841;
        }
        span {
          color: #272841;
        }
      }
    }
  }
}
.newgrey {
  .fund-history-wrap {
    .fund-history-legend {
      color: #fff;
    }
    .fund-history-radio {
      .ant-radio-wrapper {
        .ant-radio-inner {
          background: #181c21;
          border: 1px solid #fff;
        }
        .ant-radio-inner:after {
          /* background-color: #181c21; */
        }
        span {
          color: #fff;
        }
      }
    }
  }
}
</style>
